import React, { useState } from "react";
import Button from "../Button/Button";
import { useFormik } from "formik";
import { createValidationSchemas } from "../../schemas/user.schema";
import { authService } from "../../services/auth.service";
import { toast } from "react-hot-toast";
import { useTranslation } from "react-i18next";
import Input from "../input/Input";

const ResetPasswordModal = ({ setstate1, email }) => {
  const [state, setstate] = useState(true);
  const [eye, seteye] = useState(true);
  const [loading, setLoading] = useState(false);
  const { t, i18n } = useTranslation();
  const validationSchemas = createValidationSchemas(t);

  const formik = useFormik({
    initialValues: {
      password: "",
      confirm_password: "",
    },
    validationSchema: validationSchemas.validateResetpasswordForm,
    onSubmit: async (values) => {
      try {
        setLoading(true);
        const res = await authService.resetPassword({
          email: email,
          password: values.password,
        });
        
        if (res.status === 200 || res.status === 201) {
          setLoading(false);
          setstate1(8);
        }
      } catch (error) {
        console.log(error.data);
        setLoading(false);
        if (error?.response?.data?.message) {
          toast.error(error?.response?.data?.message);
        } else {
          console.log(error.response);
        }
      }
    },
  });

  return (
    <div className="w-full">
      <div className="flex flex-col gap-[3.5rem]">
        <div className="flex flex-col sm:gap-16 gap-10">
          <div>
            <h3 className="modal-heading mb-1">{t("Reset Password")}</h3>
            <p className="modal-description !text-base">
              {t("Please enter new password for your account")}
            </p>
          </div>
        </div>
        <form onSubmit={formik.handleSubmit}>
          <div className="mb-3">
            <div className="relative">
              <Input
                placeholder={t("Enter your password")}
                type={state ? "password" : "text"}
                id="password"
                name="password"
                value={formik.values.password}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </div>
            {formik.touched.password && formik.errors.password && (
              <ul className="at-error list-disc list-inside text-red-700 mt-1 text-left text-sm">
                <li>{t("Have at least 1 uppercase")}</li>
                <li>{t("Have at least 1 special character")}</li>
                <li>{t("Have at least 1 number")}</li>
                <li>{t("Have at least 8 characters")}</li>
              </ul>
            )}
          </div>
          <div className="mb-3">
            <div className="relative">
              <Input
                placeholder={t("Confirm password")}
                type={eye ? "password" : "text"}
                id="confirm_password"
                name="confirm_password"
                value={formik.values.confirm_password}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.confirm_password && formik.errors.confirm_password}
              />
            </div>
          </div>
          <Button
            type="submit"
            className="w-full mt-6"
            isLoading={loading}
            disabled={!formik.isValid || !formik.dirty || loading}
          >
            {t("Reset Password")}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default ResetPasswordModal;
